import React from "react";
import { useMediaQuery } from "usehooks-ts";
import styled from "styled-components";

const tagsGuide = {
  "ترکی دیلینده": "TURKISH_NATIVE",
  "پخش زنده": "LIVE_STREAM",
  بزودی: "COMING_SOON",
  "آنلاین باخیش": "ONLINE_CINEMA",
  آرشیو: "ARCHIVE",
};

const tagImageGuide = {
  TURKISH_NATIVE: {
    large: "/tags/turkish-native-large.svg",
    small: "/tags/turkish-native-small.svg",
    sportClassName: "w-[40%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[50%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212] border-1",
  },
  LIVE_STREAM: {
    large: "/tags/live-stream-large.svg",
    small: null,
    sportClassName: "w-[40%] bg-none shadow-none",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[150px] bg-none shadow-none",
  },
  COMING_SOON: {
    large: "/tags/coming-soon-large.svg",
    small: null,
    sportClassName: "w-[40%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[40%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
  ONLINE_CINEMA: {
    large: "/tags/online-cinema-large.svg",
    small: "/tags/online-cinema-small.svg",
    sportClassName: "w-[40%] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[40%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
  ARCHIVE: {
    large: "/tags/archive-large.svg",
    small: null,
    sportClassName:
      "w-[40%] max-w-[120px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[30%] bg-none shadow-none",
    className:
      "w-[50%] max-w-[120px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
};

const TagContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  font-size: 0.875rem;
  overflow: hidden;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
  @media (min-width: 1280px) {
    font-size: 1.25rem;
  }
  z-index: 20;
  align-items: center;
  text-align: center;
  border-radius: 0;
  border-bottom-left-radius: 2rem;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  color: white;
  padding-bottom: 10px;
  padding-left: 10px;
`;

const TagImage = styled.img`
  border-radius: 0 0 0 12px;
`;

const ContentTag = ({ label, type, relative }) => {
  const isMD = useMediaQuery("(min-width: 768px)");
  const tagCode = tagsGuide[label];

  if (!tagCode) return null;

  const tagImage = tagImageGuide[tagCode];

  const tagImageSrc =
    !isMD && tagImage?.small !== null ? tagImage?.small : tagImage?.large;

  return (
    <TagContainer className={relative ? "!relative" : ""}>
      {type === "sport" ? (
        <TagImage
          src={tagImageSrc}
          alt={label}
          className={tagImage.sportClassName}
        />
      ) : type === "animation" ? (
        <TagImage
          src={tagImageSrc}
          alt={label}
          className={tagImage.animationClassName}
        />
      ) : (
        <TagImage
          src={tagImageSrc}
          alt={label}
          className={tagImage.className}
        />
      )}
    </TagContainer>
  );
};

export default ContentTag;
